import {
  LayoutDashboard,
  TrendingUp,
  Boxes,
  FileSpreadsheet,
  Receipt,
  GitCompareArrows,
  ShieldCheck,
  Sparkles,
  Settings as SettingsIcon,
  Wallet,
  BookOpen,
  type LucideIcon,
} from "lucide-react";

export type NavGroup = {
  label: string;
  items: NavItem[];
};

export type NavItem = {
  to: string;
  label: string;
  description: string;
  icon: LucideIcon;
  testId: string;
};

// Gruplar, günlük kullanım sırasına göre sadeleştirildi.
// Hiçbir sayfa/işlev kaldırılmadı; yalnızca yinelenen açıklama metinleri menüden çıkarıldı.
export const navGroups: NavGroup[] = [
  {
    label: "Genel",
    items: [
      { to: "/dashboard", label: "Genel Bakış", description: "Dönemsel özet ve ana göstergeler", icon: LayoutDashboard, testId: "nav-dashboard" },
      { to: "/satislar", label: "Günlük Satış Analizi", description: "Günlük satış hareketleri ve kırılımlar", icon: TrendingUp, testId: "nav-sales" },
      { to: "/stok", label: "Stok ve Envanter", description: "Konum bazlı stok ve hareketler", icon: Boxes, testId: "nav-inventory" },
      { to: "/ai", label: "Yapay Zekâ Asistanı", description: "Satış, stok, fatura ve gider verileriyle analiz", icon: Sparkles, testId: "nav-ai-assistant" },
    ],
  },
  {
    label: "İşlemler",
    items: [
      { to: "/ice-aktarma/nebim", label: "Nebim Excel İçe Aktarma", description: "Satış ve stok dosyaları", icon: FileSpreadsheet, testId: "nav-nebim" },
      { to: "/ice-aktarma/besiktas", label: "Beşiktaş Faturaları", description: "Tedarikçi alış faturaları", icon: Receipt, testId: "nav-besiktas" },
      { to: "/urun-eslestirme", label: "Ürün Eşleştirme", description: "Belirsiz eşlemeler ve onay", icon: GitCompareArrows, testId: "nav-matching" },
      { to: "/veri-kontrol", label: "Veri Kontrol Merkezi", description: "İçe aktarma günlüğü ve denetim", icon: ShieldCheck, testId: "nav-data-control" },
    ],
  },
  {
    label: "Finans ve Ayarlar",
    items: [
      { to: "/cari-hareketler", label: "Cari Hareketler", description: "Beşiktaş cari hesabı ve ayrı mağaza çek hesabı", icon: BookOpen, testId: "nav-current-accounts" },
      { to: "/giderler", label: "İşletme Giderleri", description: "Aylık gider kayıtları ve toplamlar", icon: Wallet, testId: "nav-expenses" },
      { to: "/ayarlar", label: "Ayarlar", description: "Profil, şirket ve entegrasyonlar", icon: SettingsIcon, testId: "nav-settings" },
    ],
  },
];

export const flatNavItems: NavItem[] = navGroups.flatMap((g) => g.items);
